var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-3"},[_c('Header'),_c('main',[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row mt-1"},[_c('div',{staticClass:"col-lg-12 offset-lg-0"},[_c('router-view')],1)])])]),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }